// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.font_size {
  font-size: 12px !important;
}

.ng-autocompleteroutr {
  width: 370px;
}

.search_btnss {
  background-color: #17a2b8;
  color: white;
  border: none;
  outline: none;
}

.reset_btnss {
  background-color: #17a2b8;
  color: white;
  border: none;
}

::ng-deep .mat-form-field-appearance-legacy .mat-form-field-wrapper {
  margin-top: -3% !important;
  margin-left: 2% !important;
}

.link_Nonhighlight {
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90% !important;
  display: inline-block;
}

.link_highlight {
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90% !important;
  display: inline-block;
  margin-right: 1%;
}

.link_highlight:hover {
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90% !important;
  display: inline-block;
  background-color: #3fa4fb;
  padding-inline: 3%;
  padding-block: 2px;
  border-radius: 12px;
  color: white !important;
  cursor: pointer;
}

.iconCheck {
  font-size: 12px;
  position: relative;
  top: -20%;
  margin-left: -3px;
}

.doller {
  position: absolute;
  top: -11px;
  left: 15%;
}

.textCenter {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.text-success {
  color: #5dd077 !important;
}

.text-danger {
  color: #da606c !important;
}

.gui_ellipsis {
  font-weight: 600;
  max-width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
}

.pipeline_ellipsis {
  max-width: 89%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  position: relative;
  top: 8%;
  left: 1%;
  padding-right: 1%;
}

.trans_ellipsis {
  max-width: 74%;
  white-space: nowrap;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  top: 11%;
  padding-right: 1%;
}

.active_card {
  border-left: 4px solid #07a36e;
}

.progress_card {
  border-left: 4px solid #ffc107;
}

.iconPointer:hover {
  pointer-events: all;
}

.arrow_source {
  left: 5%;
  width: 97%;
  height: 2px;
  background-color: grey;
  position: relative;
  top: 36%;
}

.arr_chev {
  position: relative;
  text-align: right !important;
  right: -98%;
  color: grey;
  top: -9px;
}

.failed_card {
  border-left: 4px solid #da606c;
}

.healing_card {
  border-left: 4px solid #f5a700;
}

.border-gradient {
  border-left: 4px solid !important;
  border-image-slice: 1;
  border-block: 0;
  border-right: 0;
}

.border-gradient-redgreen {
  border-image-source: linear-gradient(to bottom, #db6c6c, #22ed86);
}

.copy_icon {
  margin-left: 2%;
  cursor: pointer;
  font-size: 15px;
}

.pipeline_label {
  float: left;
  padding-right: 11%;
  position: relative;
  top: 8px;
}

.pipeline_feild {
  float: left;
  width: 100%;
}

.source_label {
  float: left;
  padding-right: 9%;
  position: relative;
  top: 8px;
}

.source_feild {
  float: left;
  width: 100%;
}

.target_label {
  float: left;
  padding-right: 13%;
  position: relative;
  top: 8px;
}

.target_feild {
  float: left;
  width: 100%;
}

.processor_label {
  float: left;
  padding-right: 7%;
  position: relative;
  top: 8px;
}

.processor_feild {
  float: left;
  width: 100%;
}

.message_label {
  float: left;
  padding-right: 9%;
  position: relative;
  top: 8px;
}

.message_feild {
  float: left;
  width: 100%;
}

.transaction_label {
  float: left;
  padding-right: 3%;
  position: relative;
  top: 8px;
}

.transaction_feild {
  float: left;
  width: 100%;
}

.message_type_label {
  float: left;
  padding-right: 3%;
  position: relative;
  top: 8px;
}

.message_type_feild {
  width: 100%;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  padding-inline: 1%;
  top: -6px;
}

.message_type_label {
  float: left;
  padding-right: 2%;
  position: relative;
  top: 8px;
}

.message_type {
  width: 100%;
  height: 30px;
  position: relative;
}

.messagefield_label {
  float: left;
  padding-right: 2%;
  position: relative;
  top: 8px;
}

.messagefield_feild {
  float: left;
  width: 100%;
}

.btnsdiv {
  padding-left: 16%;
}

@media screen and (min-width: 900px) and (max-width: 1024px) {
  .pipeline_label {
    float: left;
    padding-right: 2%;
    position: relative;
    top: 8px;
  }
  .target_label {
    float: left;
    padding-right: 9%;
    position: relative;
    top: 8px;
  }
  .processor_label {
    float: left;
    padding-right: 2%;
    position: relative;
    top: 8px;
    font-size: 12px;
    font-weight: 700;
  }
  .processor_feild {
    float: left;
    width: 100%;
  }
  .message_label {
    float: left;
    padding-right: 1%;
    position: relative;
    top: 8px;
  }
  .transaction_label {
    float: left;
    padding-right: 2%;
    position: relative;
    top: 8px;
  }
  .transaction_feild {
    float: left;
    width: 100%;
  }
  .message_type {
    width: 53%;
    height: 35px;
    position: relative;
  }
  .message_type_margin {
    margin-left: 1% !important;
  }
  .pipeline_ellipsis {
    max-width: 85%;
  }
  .trans_ellipsis {
    max-width: 65%;
  }
  .message_btns span {
    padding: 0 !important;
  }
}
@media screen and (min-width: 500px) and (max-width: 786px) {
  .pipeline_label {
    float: left;
    padding-right: 2%;
    position: relative;
    top: 0px;
  }
  .pipeline_feild {
    float: left;
    width: 100%;
  }
  .source_label {
    float: left;
    padding-right: 6%;
    position: relative;
    top: 0px;
  }
  .source_feild {
    float: left;
    width: 100%;
  }
  .target_label {
    float: left;
    padding-right: 9%;
    position: relative;
    top: 0px;
  }
  .target_feild {
    float: left;
    width: 100%;
  }
  .processor_label {
    float: left;
    padding-right: 1%;
    position: relative;
    top: 0px;
    font-size: 12px;
    font-weight: 700;
  }
  .processor_feild {
    float: left;
    width: 100%;
  }
  .message_label {
    float: left;
    padding-right: 1%;
    position: relative;
    top: 0px;
  }
  .message_feild {
    float: left;
    width: 100%;
  }
  .transaction_label {
    float: left;
    padding-right: 2%;
    position: relative;
    top: 0px;
  }
  .transaction_feild {
    float: left;
    width: 100%;
  }
  .message_type {
    width: 86%;
    height: 35px;
    position: relative;
  }
  .reset_btn {
    padding-inline: 13% !important;
  }
  .gui_ellipsis {
    font-weight: 600;
    width: 65%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .message_type_margin {
    margin-left: 1% !important;
  }
  .pipeline_ellipsis {
    max-width: 81%;
  }
  .trans_ellipsis {
    max-width: 52%;
  }
  .message_btns span {
    padding: 0 !important;
  }
}
.rightalign {
  float: right;
  padding-right: 60px;
  padding-top: 10px;
}

::ng-deep.mat-form-field-appearance-legacy .mat-form-field-underline {
  height: 0px !important;
}

::ng-deep.mat-form-field-appearance-legacy .mat-form-field-ripple {
  top: 0;
  height: 0px !important;
  overflow: hidden;
}

.text-green {
  color: green;
}

.text-red {
  color: red;
}

::ng-deep.pipeSearch_messages .autocomplete-container .suggestions-container {
  position: absolute;
  background: #fff;
  height: auto;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
  box-sizing: border-box;
  font-size: 14px;
}

::ng-deep.messageiot .modal-dialog {
  max-width: 97% !important;
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important;
  padding: 0 !important;
}

::ng-deep.messageiot {
  top: 4% !important;
}

::ng-deep.messageioteditor .editor-container {
  overflow: hidden !important;
  position: relative !important;
  display: table !important;
  width: 100% !important;
  height: 99% !important;
  min-width: 0 !important;
}

::ng-deep.messageiot .modal-dialog .modal-content .modal-footer {
  display: unset !important;
  flex-wrap: wrap !important;
  align-items: center !important;
  justify-content: flex-end !important;
  padding: 0.3rem !important;
  border-top: 1px solid #dee2e6 !important;
  border-bottom-right-radius: calc(0.3rem - 1px) !important;
  border-bottom-left-radius: calc(0.3rem - 1px) !important;
}

.date_control_style {
  width: 100%;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  padding-inline: 2%;
}

.autocomplete-container .suggestions-container {
  position: absolute;
  background: #fff;
  height: auto;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
  box-sizing: border-box;
  font-size: 14px;
}

::ng-deep.fonts_bulkreprocess .autocomplete-container .suggestions-container {
  position: absolute;
  background: #fff;
  height: auto;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
  box-sizing: border-box;
  font-size: 14px;
}

.inIcon {
  position: relative;
  top: -15%;
}

.nav-item {
  color: #111195;
  font-size: small;
}

.mirthsuc {
  margin-left: 1%;
  width: 25%;
  display: inline-block;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow-x: hidden;
  position: relative;
  top: 6px;
}

.nav-active-indigo .nav-link.active {
  color: white !important;
  font-weight: 600 !important;
  font-size: 16px !important;
  background-color: #111195 !important;
}

.Indentifiers .nav-tabs .nav-link {
  font-weight: 600 !important;
  font-size: 12px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/message/message.component.scss"],"names":[],"mappings":"AAAA;EACE,0BAAA;AACF;;AAGA;EACE,YAAA;AAAF;;AAEA;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;AACF;;AAEA;EACE,yBAAA;EACA,YAAA;EACA,YAAA;AACF;;AAGA;EACE,0BAAA;EACA,0BAAA;AAAF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,qBAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;AADF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAAF;;AAIA;EACE,eAAA;EACA,kBAAA;EACA,SAAA;EACA,iBAAA;AADF;;AAGA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;AAAF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AACF;;AACA;EACE,yBAAA;AAEF;;AAAA;EACE,yBAAA;AAGF;;AAAA;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;AAGF;;AAAA;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,iBAAA;AAGF;;AAAA;EACE,cAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;AAGF;;AADA;EACE,8BAAA;AAIF;;AAFA;EACE,8BAAA;AAKF;;AAHA;EACE,mBAAA;AAMF;;AAJA;EACE,QAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;AAOF;;AALA;EACE,kBAAA;EACA,4BAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;AAQF;;AANA;EACE,8BAAA;AASF;;AAPA;EACE,8BAAA;AAUF;;AAPA;EACE,iCAAA;EACA,qBAAA;EACA,eAAA;EACA,eAAA;AAUF;;AARA;EACE,iEAAA;AAWF;;AATA;EACE,eAAA;EACA,eAAA;EACA,eAAA;AAYF;;AATA;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;AAYF;;AAVA;EACE,WAAA;EACA,WAAA;AAaF;;AAVA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAaF;;AAXA;EACE,WAAA;EACA,WAAA;AAcF;;AAXA;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;AAcF;;AAZA;EACE,WAAA;EACA,WAAA;AAeF;;AAZA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAeF;;AAbA;EACE,WAAA;EACA,WAAA;AAgBF;;AAdA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAiBF;;AAfA;EACE,WAAA;EACA,WAAA;AAkBF;;AAfA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAkBF;;AAhBA;EACE,WAAA;EACA,WAAA;AAmBF;;AAhBA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAmBF;;AAhBA;EACE,WAAA;EACA,+GAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;AAmBF;;AAjBA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAoBF;;AAlBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAqBF;;AAlBA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,QAAA;AAqBF;;AAnBA;EACE,WAAA;EACA,WAAA;AAsBF;;AAnBA;EACE,iBAAA;AAsBF;;AAnBA;EACE;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAsBF;EAnBA;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAqBF;EAnBA;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;IACA,eAAA;IACA,gBAAA;EAqBF;EAnBA;IACE,WAAA;IACA,WAAA;EAqBF;EAlBA;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAoBF;EAjBA;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAmBF;EAjBA;IACE,WAAA;IACA,WAAA;EAmBF;EAjBA;IACE,UAAA;IACA,YAAA;IACA,kBAAA;EAmBF;EAjBA;IACE,0BAAA;EAmBF;EAjBA;IACE,cAAA;EAmBF;EAjBA;IACE,cAAA;EAmBF;EAhBE;IACE,qBAAA;EAkBJ;AACF;AAdA;EACE;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAgBF;EAbA;IACE,WAAA;IACA,WAAA;EAeF;EAbA;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAeF;EAbA;IACE,WAAA;IACA,WAAA;EAeF;EAbA;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAeF;EAbA;IACE,WAAA;IACA,WAAA;EAeF;EAbA;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;IACA,eAAA;IACA,gBAAA;EAeF;EAbA;IACE,WAAA;IACA,WAAA;EAeF;EAZA;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAcF;EAZA;IACE,WAAA;IACA,WAAA;EAcF;EAZA;IACE,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,QAAA;EAcF;EAZA;IACE,WAAA;IACA,WAAA;EAcF;EAZA;IACE,UAAA;IACA,YAAA;IACA,kBAAA;EAcF;EAXA;IACE,8BAAA;EAaF;EAVA;IACE,gBAAA;IACA,UAAA;IACA,mBAAA;IACA,gBAAA;IACA,uBAAA;EAYF;EAVA;IACE,0BAAA;EAYF;EAVA;IACE,cAAA;EAYF;EAVA;IACE,cAAA;EAYF;EATE;IACE,qBAAA;EAWJ;AACF;AALA;EACE,YAAA;EACA,mBAAA;EACA,iBAAA;AAOF;;AAHA;EACE,sBAAA;AAMF;;AAHA;EACE,MAAA;EACA,sBAAA;EACA,gBAAA;AAMF;;AAHA;EACE,YAAA;AAMF;;AAJA;EACE,UAAA;AAOF;;AAJA;EACE,kBAAA;EAEA,gBAAA;EACA,YAAA;EACA,yCAAA;EACA,sBAAA;EACA,eAAA;AAMF;;AAHA;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AAMF;;AAJA;EACE,kBAAA;AAOF;;AAJA;EACE,2BAAA;EACE,6BAAA;EACA,yBAAA;EACA,sBAAA;EACA,sBAAA;EACA,uBAAA;AAOJ;;AAJA;EACE,yBAAA;EACA,0BAAA;EACE,8BAAA;EACA,oCAAA;EACA,0BAAA;EACA,wCAAA;EACA,yDAAA;EACA,wDAAA;AAOJ;;AAJA;EACE,WAAA;EACA,+GAAA;EACA,kBAAA;EACA,kBAAA;AAOF;;AAJA;EACE,kBAAA;EAEA,gBAAA;EACA,YAAA;EACA,yCAAA;EACA,sBAAA;EACA,eAAA;AAMF;;AAHA;EACE,kBAAA;EAEA,gBAAA;EACA,YAAA;EACA,yCAAA;EACA,sBAAA;EACA,eAAA;AAKF;;AAFA;EACE,kBAAA;EACA,SAAA;AAKF;;AADA;EACE,cAAA;EAGA,gBAAA;AAEF;;AACA;EACE,eAAA;EACA,UAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;AAEF;;AAAA;EACE,uBAAA;EACA,2BAAA;EACA,0BAAA;EACA,oCAAA;AAGF;;AADA;EAEE,2BAAA;EACA,0BAAA;AAGF","sourcesContent":[".font_size{\r\n  font-size: 12px !important;\r\n}\r\n\r\n\r\n.ng-autocompleteroutr {\r\n  width: 370px;\r\n}\r\n.search_btnss {\r\n  background-color: #17a2b8;\r\n  color: white;\r\n  border: none;\r\n  outline: none;\r\n}\r\n\r\n.reset_btnss {\r\n  background-color: #17a2b8;\r\n  color: white;\r\n  border: none;\r\n}\r\n\r\n\r\n::ng-deep .mat-form-field-appearance-legacy .mat-form-field-wrapper {\r\n  margin-top: -3% !important;\r\n  margin-left: 2% !important;\r\n  // padding-bottom: 10% !important;\r\n}\r\n\r\n.link_Nonhighlight{\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  max-width: 90% !important;\r\n  display: inline-block;\r\n}\r\n\r\n.link_highlight{\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  max-width: 90% !important;\r\n  display: inline-block;\r\n  margin-right: 1%;\r\n}\r\n.link_highlight:hover{\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  max-width: 90% !important;\r\n  display: inline-block;\r\n  background-color: #3fa4fb;\r\n  padding-inline: 3%;\r\n  padding-block: 2px;\r\n  border-radius: 12px;\r\n  color: white !important;\r\n  cursor: pointer;\r\n\r\n}\r\n\r\n.iconCheck {\r\n  font-size: 12px;\r\n  position: relative;\r\n  top: -20%;\r\n  margin-left: -3px;\r\n}\r\n.doller {\r\n  position: absolute;\r\n  top: -11px;\r\n  left: 15%;\r\n}\r\n.textCenter {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n}\r\n.text-success {\r\n  color: #5dd077 !important;\r\n}\r\n.text-danger {\r\n  color: #da606c !important;\r\n}\r\n\r\n.gui_ellipsis {\r\n  font-weight: 600;\r\n  max-width: 90%;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  display: inline-block;\r\n}\r\n\r\n.pipeline_ellipsis {\r\n  max-width: 89%;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  display: inline-block;\r\n  position: relative;\r\n  top: 8%;\r\n  left: 1%;\r\n  padding-right: 1%;\r\n}\r\n\r\n.trans_ellipsis {\r\n  max-width: 74%;\r\n  white-space: nowrap;\r\n  display: inline-block;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  position: relative;\r\n  top: 11%;\r\n  padding-right: 1%;\r\n}\r\n.active_card {\r\n  border-left: 4px solid #07a36e;\r\n}\r\n.progress_card {\r\n  border-left: 4px solid #ffc107;\r\n}\r\n.iconPointer:hover {\r\n  pointer-events: all;\r\n}\r\n.arrow_source {\r\n  left: 5%;\r\n  width: 97%;\r\n  height: 2px;\r\n  background-color: grey;\r\n  position: relative;\r\n  top: 36%;\r\n}\r\n.arr_chev {\r\n  position: relative;\r\n  text-align: right !important;\r\n  right: -98%;\r\n  color: grey;\r\n  top: -9px;\r\n}\r\n.failed_card {\r\n  border-left: 4px solid #da606c;\r\n}\r\n.healing_card {\r\n  border-left: 4px solid  #f5a700;\r\n}\r\n\r\n.border-gradient {\r\n  border-left: 4px solid !important;\r\n  border-image-slice: 1;\r\n  border-block: 0;\r\n  border-right: 0;\r\n}\r\n.border-gradient-redgreen {\r\n  border-image-source: linear-gradient(to bottom, #db6c6c, #22ed86);\r\n}\r\n.copy_icon {\r\n  margin-left: 2%;\r\n  cursor: pointer;\r\n  font-size: 15px;\r\n}\r\n\r\n.pipeline_label {\r\n  float: left;\r\n  padding-right: 11%;\r\n  position: relative;\r\n  top: 8px;\r\n}\r\n.pipeline_feild {\r\n  float: left;\r\n  width: 100%;\r\n}\r\n\r\n.source_label {\r\n  float: left;\r\n  padding-right: 9%;\r\n  position: relative;\r\n  top: 8px;\r\n}\r\n.source_feild {\r\n  float: left;\r\n  width: 100%;\r\n}\r\n\r\n.target_label {\r\n  float: left;\r\n  padding-right: 13%;\r\n  position: relative;\r\n  top: 8px;\r\n}\r\n.target_feild {\r\n  float: left;\r\n  width: 100%;\r\n}\r\n\r\n.processor_label {\r\n  float: left;\r\n  padding-right: 7%;\r\n  position: relative;\r\n  top: 8px;\r\n}\r\n.processor_feild {\r\n  float: left;\r\n  width: 100%;\r\n}\r\n.message_label {\r\n  float: left;\r\n  padding-right: 9%;\r\n  position: relative;\r\n  top: 8px;\r\n}\r\n.message_feild {\r\n  float: left;\r\n  width: 100%;\r\n}\r\n\r\n.transaction_label {\r\n  float: left;\r\n  padding-right: 3%;\r\n  position: relative;\r\n  top: 8px;\r\n}\r\n.transaction_feild {\r\n  float: left;\r\n  width: 100%;\r\n}\r\n\r\n.message_type_label {\r\n  float: left;\r\n  padding-right: 3%;\r\n  position: relative;\r\n  top: 8px;\r\n}\r\n\r\n.message_type_feild {\r\n  width: 100%;\r\n  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n  border-radius: 5px;\r\n  padding-inline: 1%;\r\n  top: -6px;\r\n}\r\n.message_type_label {\r\n  float: left;\r\n  padding-right: 2%;\r\n  position: relative;\r\n  top: 8px;\r\n}\r\n.message_type {\r\n  width: 100%;\r\n  height: 30px;\r\n  position: relative;\r\n}\r\n\r\n.messagefield_label {\r\n  float: left;\r\n  padding-right: 2%;\r\n  position: relative;\r\n  top: 8px;\r\n}\r\n.messagefield_feild {\r\n  float: left;\r\n  width: 100%;\r\n}\r\n\r\n.btnsdiv {\r\n  padding-left: 16%;\r\n}\r\n\r\n@media screen and (min-width: 900px) and (max-width: 1024px) {\r\n  .pipeline_label {\r\n    float: left;\r\n    padding-right: 2%;\r\n    position: relative;\r\n    top: 8px;\r\n  }\r\n\r\n  .target_label {\r\n    float: left;\r\n    padding-right: 9%;\r\n    position: relative;\r\n    top: 8px;\r\n  }\r\n  .processor_label {\r\n    float: left;\r\n    padding-right: 2%;\r\n    position: relative;\r\n    top: 8px;\r\n    font-size: 12px;\r\n    font-weight: 700;\r\n  }\r\n  .processor_feild {\r\n    float: left;\r\n    width: 100%;\r\n  }\r\n\r\n  .message_label {\r\n    float: left;\r\n    padding-right: 1%;\r\n    position: relative;\r\n    top: 8px;\r\n  }\r\n\r\n  .transaction_label {\r\n    float: left;\r\n    padding-right: 2%;\r\n    position: relative;\r\n    top: 8px;\r\n  }\r\n  .transaction_feild {\r\n    float: left;\r\n    width: 100%;\r\n  }\r\n  .message_type {\r\n    width: 53%;\r\n    height: 35px;\r\n    position: relative;\r\n  }\r\n  .message_type_margin {\r\n    margin-left: 1% !important;\r\n  }\r\n  .pipeline_ellipsis {\r\n    max-width: 85%;\r\n  }\r\n  .trans_ellipsis {\r\n    max-width: 65%;\r\n  }\r\n  .message_btns {\r\n    span {\r\n      padding: 0 !important;\r\n    }\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 500px) and (max-width: 786px) {\r\n  .pipeline_label {\r\n    float: left;\r\n    padding-right: 2%;\r\n    position: relative;\r\n    top: 0px;\r\n  }\r\n\r\n  .pipeline_feild {\r\n    float: left;\r\n    width: 100%;\r\n  }\r\n  .source_label {\r\n    float: left;\r\n    padding-right: 6%;\r\n    position: relative;\r\n    top: 0px;\r\n  }\r\n  .source_feild {\r\n    float: left;\r\n    width: 100%;\r\n  }\r\n  .target_label {\r\n    float: left;\r\n    padding-right: 9%;\r\n    position: relative;\r\n    top: 0px;\r\n  }\r\n  .target_feild {\r\n    float: left;\r\n    width: 100%;\r\n  }\r\n  .processor_label {\r\n    float: left;\r\n    padding-right: 1%;\r\n    position: relative;\r\n    top: 0px;\r\n    font-size: 12px;\r\n    font-weight: 700;\r\n  }\r\n  .processor_feild {\r\n    float: left;\r\n    width: 100%;\r\n  }\r\n\r\n  .message_label {\r\n    float: left;\r\n    padding-right: 1%;\r\n    position: relative;\r\n    top: 0px;\r\n  }\r\n  .message_feild {\r\n    float: left;\r\n    width: 100%;\r\n  }\r\n  .transaction_label {\r\n    float: left;\r\n    padding-right: 2%;\r\n    position: relative;\r\n    top: 0px;\r\n  }\r\n  .transaction_feild {\r\n    float: left;\r\n    width: 100%;\r\n  }\r\n  .message_type {\r\n    width: 86%;\r\n    height: 35px;\r\n    position: relative;\r\n  }\r\n\r\n  .reset_btn {\r\n    padding-inline: 13% !important;\r\n  }\r\n\r\n  .gui_ellipsis {\r\n    font-weight: 600;\r\n    width: 65%;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n  }\r\n  .message_type_margin {\r\n    margin-left: 1% !important;\r\n  }\r\n  .pipeline_ellipsis {\r\n    max-width: 81%;\r\n  }\r\n  .trans_ellipsis {\r\n    max-width: 52%;\r\n  }\r\n  .message_btns {\r\n    span {\r\n      padding: 0 !important;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n\r\n.rightalign {\r\n  float: right;\r\n  padding-right: 60px;\r\n  padding-top: 10px;\r\n}\r\n\r\n\r\n::ng-deep.mat-form-field-appearance-legacy .mat-form-field-underline{\r\n  height: 0px !important;\r\n}\r\n\r\n::ng-deep.mat-form-field-appearance-legacy .mat-form-field-ripple {\r\n  top: 0;\r\n  height: 0px !important;\r\n  overflow: hidden;\r\n}\r\n\r\n.text-green{\r\n  color:green\r\n}\r\n.text-red{\r\n  color:red;\r\n}\r\n\r\n::ng-deep.pipeSearch_messages .autocomplete-container .suggestions-container {\r\n  position: absolute;\r\n  // width: 170% !important;\r\n  background: #fff;\r\n  height: auto;\r\n  box-shadow: 0 2px 5px rgb(0 0 0 / 25%);\r\n  box-sizing: border-box;\r\n  font-size: 14px;\r\n}\r\n\r\n::ng-deep.messageiot .modal-dialog {\r\n  max-width: 97%!important;\r\n  max-height: 60%!important;\r\n  height: 60%!important;\r\n  margin: auto!important;\r\n  padding: 0 !important;\r\n}\r\n::ng-deep.messageiot{\r\n  top: 4%!important;\r\n}\r\n\r\n::ng-deep.messageioteditor .editor-container{\r\n  overflow: hidden!important;\r\n    position: relative!important;\r\n    display: table!important;\r\n    width: 100%!important;\r\n    height: 99%!important;\r\n    min-width: 0!important;\r\n}\r\n\r\n::ng-deep.messageiot .modal-dialog .modal-content .modal-footer{\r\n  display: unset!important;\r\n  flex-wrap: wrap!important;\r\n    align-items: center!important;\r\n    justify-content: flex-end!important;\r\n    padding: 0.3rem!important;\r\n    border-top: 1px solid #dee2e6!important;\r\n    border-bottom-right-radius: calc(0.3rem - 1px)!important;\r\n    border-bottom-left-radius: calc(0.3rem - 1px)!important;\r\n}\r\n\r\n.date_control_style{\r\n  width: 100%;\r\n  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n  border-radius: 5px;\r\n  padding-inline: 2%;\r\n  // padding-block: 3%;\r\n}\r\n.autocomplete-container .suggestions-container {\r\n  position: absolute;\r\n\r\n  background: #fff;\r\n  height: auto;\r\n  box-shadow: 0 2px 5px rgb(0 0 0 / 25%);\r\n  box-sizing: border-box;\r\n  font-size: 14px;\r\n}\r\n\r\n::ng-deep.fonts_bulkreprocess .autocomplete-container .suggestions-container {\r\n  position: absolute;\r\n  // width: 170%;\r\n  background: #fff;\r\n  height: auto;\r\n  box-shadow: 0 2px 5px rgb(0 0 0 / 25%);\r\n  box-sizing: border-box;\r\n  font-size: 14px;\r\n}\r\n\r\n.inIcon{\r\n  position: relative;\r\n  top:-15%;\r\n}\r\n\r\n\r\n.nav-item {\r\n  color: #111195;\r\n  // height: 35px;\r\n  // line-height: 1;\r\n  font-size:small;\r\n}\r\n\r\n.mirthsuc{\r\n  margin-left: 1%;\r\n  width: 25%;\r\n  display: inline-block;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  overflow-x: hidden;\r\n  position: relative;\r\n  top: 6px;\r\n}\r\n.nav-active-indigo .nav-link.active {\r\n  color: white !important;\r\n  font-weight: 600 !important;\r\n  font-size: 16px !important;\r\n  background-color: #111195 !important\r\n}\r\n.Indentifiers .nav-tabs .nav-link {\r\n  // color: #111195 !important;\r\n  font-weight: 600 !important;\r\n  font-size: 12px !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
